import { Component, OnInit, TemplateRef } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { CommonCmsResponse } from '../../../../models';
import {
  AuctionDataReqType,
  AuctionService,
  CmsService,
  ContactUsService,
  LoaderService,
  EventBusService,
} from '../../../../services';
import { Observable } from 'rxjs';
import constants from '../../../../utility/constants';
import routeTable from '../../../../utility/routeTable';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { AppValidators } from '../../../../core/validators/app-validators';
import { ToastrService } from 'ngx-toastr';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import {  Subscription } from 'rxjs';
import { environment } from '../../../../../environments/environment';

export enum StaticPage {
  REMOVAL = 1,
  VALUATIONS,
  WHOWEARE,
  WHYUS,
  CLIENTS,
  HISTORY,
  SELLER,
  ASSET_RECOVERY,
  PAYMENTS,
  FAQ,
}

export enum modal {
  Location = 1,
  Contact,
}

@Component({
  selector: 'app-common-cms',
  templateUrl: './common-cms.component.html',
  styleUrls: ['./common-cms.component.css'],
})
export class CommonCmsComponent implements OnInit {
  captcha = new FormControl();
  modalRef: BsModalRef;
  routeData: CommonCmsResponse;
  content: string = '';
  captchaKey: string;
  private subscriptions: Array<Subscription> = [];

  // enum
  staticPage = StaticPage;

  currentStaticPage: number;

  cmsPageByRoute = constants.public.commonCms;

  cmsPageIds = constants.common.cmsPages;

  routes = routeTable.public;
  paymentDocuments: Array<any>;
  whyChooseSlider = {
    infinite: true,
    autoplay: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: true,
    arrows: false,
  };

  whyChooseSlider2 = {
    infinite: true,
    autoplay: true,
    autoplaySpeed: 9000,
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: true,
    arrows: false,
  };

  financstrslider = {
    infinite: true,
    autoplay: true,
    autoplaySpeed: 9000,
    slidesToShow: 3,
    slidesToScroll: 1,
    dots: true,
    centerMode: true,
    variableWidth: true,
    arrows: true,
    speed: 500,
    cssEase: 'linear',
    responsive: [
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          centerMode: false,
          variableWidth: false,
        },
      },
      {
        breakpoint: 575,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          centerMode: false,
          variableWidth: false,
        },
      },
    ],
  };

  cmsHistorySliderConfig = {
    infinite: true,
    autoplay: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    dots: false,
    centerMode: true,
    centerPadding: '50px',
    variableWidth: true,
    arrows: true,
    speed: 500,
    cssEase: 'linear',
    responsive: [
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 575,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  contactForm: FormGroup;
  fieldMaxLength10 = constants.common.validations.maxLength10;
  fieldMaxLength30 = constants.common.validations.maxLength30;
  fieldMaxLength20 = constants.common.validations.maxLength20;
  fieldMaxLength50 = constants.common.validations.maxLength50;
  fieldMaxLength500 = constants.common.validations.maxLength500;

  backgroundPic: string = '';
  removalDocuments: any[];
  dataAssets: any;
  viewDetails: any;

  constructor(
    private modalService: BsModalService,
    private cmsService: CmsService,
    private contactUsService: ContactUsService,
    private route: ActivatedRoute,
    private loader: LoaderService,
    private toastr: ToastrService,
    public ebs: EventBusService,
    private router: Router,
    private auctionService: AuctionService
  ) {}

  ngOnInit(): void {
    this.captchaKey = environment.captchaSiteKey;
    this.route.data.subscribe((res: CommonCmsResponse) => {
      this.routeData = res;
      this.loadPage(res.page);
    });
  }

  openModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(
      template,
      Object.assign({
        class: 'custom-popup viewApprisal modal-dialog modal-dialog-centered',
      })
    );
  }

  private loadPage(pageType: string) {
    let getDataSub$: Observable<string>;
    this.backgroundPic = this.cmsPageByRoute[pageType].headerBg;
    let assetTypes = constants.admin.assetType;
    let reqTypes = AuctionDataReqType;
    
    switch (pageType) {
      case this.cmsPageByRoute.valuations.page:
        this.currentStaticPage = this.staticPage.VALUATIONS;
        this.initiateForm();
        break;
      case this.cmsPageByRoute.removal.page:
        this.currentStaticPage = this.staticPage.REMOVAL;
        const publicDocuments = this.auctionService
          .getPublicDocumentsData(reqTypes.documents, assetTypes.document)
          .subscribe(
            (res: any) => {
              this.removalDocuments = res;
            },
            () => this.loader.showLoader(false)
          );
            this.subscriptions.push(publicDocuments)
        break;
      case this.cmsPageByRoute.aboutUs.page:
        this.currentStaticPage = this.staticPage.WHOWEARE;
        this.initiateForm();
        break;
      case this.cmsPageByRoute.history.page:
        this.currentStaticPage = this.staticPage.HISTORY;
        break;
      case this.cmsPageByRoute.whyBranford.page:
        this.currentStaticPage = this.staticPage.WHYUS;
        this.initiateForm();
        break;
      case this.cmsPageByRoute.sellers.page:
        this.currentStaticPage = this.staticPage.SELLER;
        this.initiateForm();
        break;
      case this.cmsPageByRoute.assetRecovery.page:
        this.currentStaticPage = this.staticPage.ASSET_RECOVERY;
        this.getDataOfAssets();
        this.initiateForm();
        break;
      case this.cmsPageByRoute.faq.page:
        this.currentStaticPage = this.staticPage.FAQ;
        const publicAssetDocuments = this.auctionService
          .getPublicDocumentsData(reqTypes.documents, assetTypes.document)
          .subscribe(
            (res: any) => {
              this.removalDocuments = res;
            },
            () => this.loader.showLoader(false)
          );
          this.subscriptions.push(publicAssetDocuments)
          const paymentDocuments = this.auctionService
          .getPublicDocumentsData(
            reqTypes.documents,
            assetTypes.paymentDocument
          )
          .subscribe(
            (res: any) => {
              this.paymentDocuments = res;
            },
            () => this.loader.showLoader(false)
          );
          this.subscriptions.push(paymentDocuments)
        break;
      case this.cmsPageByRoute.payments.page:
        this.currentStaticPage = this.staticPage.PAYMENTS;
        getDataSub$ = this.cmsService.GetCmsPublic(this.cmsPageIds.fePayment);
        const publicAssetTypesDocuments = this.auctionService
          .getPublicDocumentsData(reqTypes.documents, assetTypes.document)
          .subscribe(
            (res: any) => {
              this.removalDocuments = res;
            },
            () => this.loader.showLoader(false)
          );
          this.subscriptions.push(publicAssetTypesDocuments)
        break;
      case this.cmsPageByRoute.buyAssets.page:
        getDataSub$ = this.cmsService.GetCmsPublic(
          this.cmsPageIds.buyUserAssets
        );
        break;
      case this.cmsPageByRoute.privacyPolicy.page:
        getDataSub$ = this.cmsService.GetCmsPublic(
          this.cmsPageIds.privacyPolicy
        );
        break;
      case this.cmsPageByRoute.sellAssets.page:
        getDataSub$ = this.cmsService.GetCmsPublic(this.cmsPageIds.sellAssets);
        break;
      case this.cmsPageByRoute.tAndC.page:
        getDataSub$ = this.cmsService.GetCmsPublic(
          this.cmsPageIds.termsAndConditions
        );
        break;
      case this.cmsPageByRoute.valueAssets.page:
        getDataSub$ = this.cmsService.GetCmsPublic(
          this.cmsPageIds.valueYourAssets
        );
        break;
    }

    if (getDataSub$) {
      this.loader.showLoader(true);
      getDataSub$.subscribe((response: any) => {
        this.content = response;
        this.loader.showLoader(false);
      });
    }
  }
  isReadMore = false;

  getSplitData(key)
  {
    return key.replace(/^(.{150}[^\s]*).*/, "$1");
  }

  openPopUpDetail(data, index, template: TemplateRef<any>) {
    this.viewDetails = this.dataAssets.find((item) => item.id == data.id);
    this.modalRef = this.modalService.show(
      template,
      Object.assign(
        {},
        {
          class: 'team-member-modal modal-dialog modal-dialog-centered',
        }
      )
    );
  }

  getDataOfAssets() {
    this.dataAssets = [
      {
        id: 1,
        title: 'Buyers Premium',
        description:
             'Under this structure, our primary compensation is through the Buyer’s Premium (BP) which is a percentage added to the final bid amount and or “hammer price” paid solely by the successful bidder for that lot. Developed several decades ago, it was primarily designed as a vehicle for the buyers to share in the auctioneer’s compensation and generate a higher net return for the seller. Today the BP is a standard charge within the auction industry across the globe whether you are selling antiques, collector automobiles, construction equipment, real estate, or industrial assets. This structure typically delivers our seller’s the maximum recovery award however does not mitigate downside risk. The preferred structure for larger fortune 100 & 500 companies thus affording them flexibility in asset changes.',
      },
      {
        id: 4,
        title: 'Commission & Expense',
        description:
            'A very simple and straight forward approach in which we work for a percentage of gross proceeds. In addition, we submit a not to exceed expense budget for marketing and operational costs in which we are entitled to reimbursement. Like in all of our structures, Branford advances all up-front costs and deducts them post auction upon settlement. There is no out of pocket costs for Seller’s to engage our services.',
      },
      {
        id: 3,
        title: 'Net Minimum Guaranteed Proceeds with Seller Participation',
        description:
            'Under this scenario, we will provide the seller with a guaranteed minimum return as well as participation in the majority share of any upside. The guarantee provides the seller with a safety net along with vast upside potential. Once the guarantee amount is achieved, a pre-negotiated amount initially goes to us for expenses and risk, then the balance is shared amongst Branford and the Seller in which the seller typically has the majority share. Most definitely one of the more popular structures amongst financial institutions and trustees.',
      },
      {
        id: 2,
        title: 'Outright Purchase',
        description:
            'Many sellers have early financial requirements at the initial stages of a closure-asset disposition or do not prefer the inherent risks and uncertainly associated with an auction. In this scenario, we negotiate and purchase the assets outright in which 100% is typically funded within 24 hours of a bill of sale execution. This is a very common structure for both state level and federal bankruptcy cases but also our private sellers.',
    },
      {
        id: 5,
          title: 'Real Estate',
        description:
            'Frequently in a closure, the Real Property may also be available for sale and taking advantage of a well targeted accelerated marketing campaign can often times prove to be quite effective in executing a sale of the Real Estate. We can work under many structures; offer the property at auction, market it privately, work as a co-broker, and in many scenarios purchase the property outright along with the assets.',
      },
    ];
  }

  private initiateForm() {
    this.contactForm = new FormGroup({
      firstName: new FormControl(null, [
        Validators.required,
        AppValidators.onlyAlphaNumeric,
        AppValidators.noWhitespace,
        Validators.maxLength(this.fieldMaxLength20),
      ]),
      lastName: new FormControl(null, [
        Validators.required,
        AppValidators.onlyAlphaNumeric,
        AppValidators.noWhitespace,
        Validators.maxLength(this.fieldMaxLength20),
      ]),
      email: new FormControl(null, [
        Validators.required,
        AppValidators.noWhitespace,
        Validators.maxLength(this.fieldMaxLength50),
        AppValidators.checkEmail,
      ]),
      mobileNumber: new FormControl(null, [
        Validators.required,
        Validators.minLength(this.fieldMaxLength10),
        Validators.maxLength(this.fieldMaxLength30),
        AppValidators.noWhitespace,
      ]),
      companyName: new FormControl(null, [
        Validators.required,
        AppValidators.onlyAlphaNumeric,
        AppValidators.noWhitespace,
        Validators.maxLength(this.fieldMaxLength50),
      ]),
      message: new FormControl(null, [
        Validators.required,
        AppValidators.noWhitespace,
        Validators.maxLength(this.fieldMaxLength500),
      ]),
    });
  }

  toPascalCase(path) {
    return path
    .toLowerCase()
    .split('/')
    .filter(Boolean)
    .map((segment, index) =>
      index === 0
      ? segment.charAt(0).toUpperCase() + segment.slice(1)
      : segment)
    .join('-');
  }

  submitForm() {
    if (this.contactForm.invalid) return;

    this.loader.showLoader(true);
    const path = window.location.pathname;
    const capitalizedPath = this.toPascalCase(path);
    let model = {
      firstName: this.contactForm.value.firstName,
      lastName: this.contactForm.value.lastName,
      mobileNumber: this.contactForm.value.mobileNumber,
      email: this.contactForm.value.email,
      companyName: this.contactForm.value.companyName,
      message: this.contactForm.value.message,
      pagePath: capitalizedPath ?? ""
    };

    const addContact = this.contactUsService.addContactUs(model).subscribe(
      (response: any) => {
        this.toastr.success(
          response,
          constants.common.toast.successTitle,
          constants.common.toast.config
        );
        this.resetForm();
        this.loader.showLoader(false);
      },
      (err) => {
        this.toastr.error(
          err,
          constants.common.toast.errorTitle,
          constants.common.toast.config
        );
        this.loader.showLoader(false);
      }
    );
      this,this.subscriptions.push(addContact)
  }

  private resetForm() {
    this.contactForm.reset({
      firstName: null,
      lastName: null,
      companyName: null,
      mobileNumber: null,
      email: null,
      message: '-',
    });
  }

  scroll(el: HTMLElement) {
    el.scrollIntoView();
  }

  goToForgetPassword() {
    this.router.navigate(['/']);
    this.ebs.notification.emit('forget-password');
  }

  ngOnDestroy() {
    this.subscriptions.forEach((sub: Subscription) => {
      sub.unsubscribe();
    });
  }
}
